Ext.define('SA.LocationsReferenceTracker', {
    singleton: true,

    constructor() {
        this.referencers = new Set();
    },

    purgeUnreferencedFromCache() {
        var referenced = SA.Array.unique([
            Array.from(this.referencers).map(getReferencedIds),
            SA.data.CustomLocations.getAll().map(location => [location.id, location.locationSeries]),
            SA.data.DmaLocations.all.map(location => location.locationSeries),
            SA.data.FavoriteLocations.getIds().map(({id}) => id),
            SA.data.Projects.getAllLocations(),
            SA.data.RecentLocations.getIds().map(({id}) => id),
            SA.Institution.getLocationSeriesForCountries()
        ]);

        SA.data.LocationsCache.purgeLocationsExcept(referenced);

        function getReferencedIds(referencer) {
            return referencer.getReferencedLocations().map(location => SA.data.LocationsCache.toLocationSeries(location));
        }
    },

    registerReferencer(referencer) {
        this.referencers.add(referencer);
    },

    unregisterReferencer(referencer) {
        this.referencers.delete(referencer);
    }
});